(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/account-selector/assets/javascripts/views/account-selector.js') >= 0) return;  svs.modules.push('/components/syndicate/account-selector/assets/javascripts/views/account-selector.js');

(function(Backbone, svs) {
  'use strict';

  svs.syndicate.account_selector.views.AccountSelector = Marionette.View.extend({
    className: 'account-selector list-group list-group-default padding-1',

    regions: {
      'account-list': '.account-selector-syndicate-wrap',
      'player-account': '.player-account'
    },

    template: function(data) {
      return svs.syndicate.account_selector.templates.account_selector(data);
    },

    onChildviewAccountClick: function(childAccount) {
      this.selectedAccountId = childAccount.model ? childAccount.model.get('syndicateId') : this.model.get('syndicateId');
    },

    onRender: function() {
      var self = this;
      if (!this.collection.length) {
        this.loader = new svs.ui.Loader();
        this.loader.show();
        this.listenToOnce(this.collection, 'sync', function() {
          self.loader.hide();
          self.trigger('modalContentResize');
        });
      } else {
        this.showChildView(
          'player-account',
          new svs.syndicate.account_selector.views.PlayerAccount({
            model: this.model
          })
        );

        this.showChildView(
          'account-list',
          new svs.syndicate.account_selector.views.AccountSelectorList({
            collection: this.collection,
            initialAccountId: svs.syndicate.AccountSelector.getActiveAccountId()
          })
        );
      }
    }
  });
})(Backbone, svs);


 })(window);